import { BooleanInput, DateInput, required, TextInput } from 'react-admin';
import { StateInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import { AddAddressFormProps } from '../types';
import useController from './useController';

const FormContent = (props: AddAddressFormProps) => {
  const { handleAddAddress } = useController(props);

  return (
    <>
      <TextInput source={path('address1')} label="Street" validate={required()} />
      <TextInput source={path('address2')} label="Neighborhood" />
      <TextInput source={path('city')} validate={required()} />
      <TextInput source={path('county')} />
      <StateInput label="State" include_prefix={false} source={path('state')} validate={required()} />
      <TextInput source={path('zip')} validate={required()} />
      <TextInput source={path('zip4')} />
      <TextInput source={path('latitude')} />
      <TextInput source={path('longitude')} />
      <DateInput source={path('first_seen')} validate={required()} />
      <DateInput source={path('last_seen')} validate={required()} />
      <BooleanInput source={path('is_current_address')} label="Set as current" defaultValue={true} />

      <DefaultToolbarStyled onClose={props.onClose} onSave={handleAddAddress} saveButtonLabel="Add" />
    </>
  );
};

export default FormContent;
